export default "__VITE_ASSET__DxfTPZFr__"